// eslint-disable-next-line
const theme = {
  colors: {
    primary: "#12477C",
    primary_dark: "#07254F",
    button_primary: "#12477C",
    button_secundary: "#24CC63",
    error: "#ED1616",
    white: "#FFF",
    black: "#000",
    title_login: "#5E5873",
    text_login: "#6E6B7B",
    text_footer: "#9B9B9B",
  },
};
export default theme;
